import React from 'react';
import ProductCategoryPage from '../../components/ProductsList/ProductCategoryPage';
import { facilitiesProducts } from '../../data/products';

export default function Facilities() {
  return (
    <ProductCategoryPage
      title="도로환경 개선시설"
      subtitle={"도로 작업 근무 환경을 개선하고, \n도로 이용자의 편의를 증진시킵니다"}
      products={facilitiesProducts}
    />
  );
}
